import {Component, OnDestroy, OnInit} from "@angular/core";
import {Field} from "../models/field.model";
import {ENVIRONMENT} from "../../../../environments/environment";
import {Subscription} from "rxjs/internal/Subscription";
import {SharedDataService} from "../../../services/shared/shared-data.service";


@Component({
	selector: "tig-form-input", template: `
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[class.has-error]="isInvalid()">
			<ng-template #tooltipTemplate>
				<div [innerHtml]="getHint()|translate"></div>
			</ng-template>
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				   [tooltip]="tooltipTemplate"
				   placement="top"
				   triggers="click"
				   containerClass="tig-tooltip"
				   delay="50"></i> <span *ngIf="isRequired()" class="tgi-asterisk"> *</span> </label>
			<div class="col-lg-8">
				<input
					title="{{getHint()|translate}}"
					class="form-control"
					[placeholder]="getLabelName()|translate"
					[formControlName]="OBJ_field_config.name"
					(blur)="setValue($event)"
				/>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="getFormControl()"></tig-form-error>
				<tig-form-warning [OBJ_form_control]="getFormControl()" [field_config]="getFieldConfig()" ></tig-form-warning>
				<div *ngIf="extern_link.has">
					<a href="{{extern_link.href}}"
					   target="{{extern_link.target}}k">
						{{extern_link.text|translate}}
						<i class="fa fa-external-link"></i> </a>
				</div>
			</div>
		</div>
	`
})
export class FormInputComponent extends Field implements OnInit, OnDestroy {

	private subscriptions: Subscription[] = [Subscription.EMPTY]
	public extern_link = {
		has: false,
		href: "",
		target: "_blank",
		text: ""
	};
	wcms: string = "";

	constructor(private subscription_service: SharedDataService,) {
		super();
		if (ENVIRONMENT.env === 'development') {
			this.wcms = 'wcms/';
		}
	}

	ngOnInit(): void {
		console.log(this.getFormControl());

		if (this.OBJ_field_config.value && this.OBJ_field_config._links) {
			let links = this.OBJ_field_config._links;
			if (links.route) {
				let route = links.route;
				this.extern_link.has = true;
				this.extern_link.text = (route.label ? route.label : "oMisc.sCorrespodingEntry");
				this.extern_link.href = route.href;
				if (this.extern_link.href.includes("http")) {
					if (route.append_value) {
						this.extern_link.href += encodeURIComponent(this.OBJ_field_config.value);
					}
				} else {
					this.extern_link.href = this.wcms + this.extern_link.href + '/' + this.OBJ_field_config.value;
				}
			}

		}

		if (this.OBJ_field_config.externally_editable) {
			this.subscription_service.createSubject(this.OBJ_field_config.name + "_external");

			this.subscriptions.push(this.subscription_service.getValue(this.OBJ_field_config.name + "_external").subscribe(
				value => {
					// Nur weiter, wenn value befuellt ist
					if (value) {
						this.markAsDirtyAndTouched();
						// Setze neuen Wert - sowohl in der Formcontrol als auch in der Config selbst (Anzeige & Abspeicherung)
						super.setValue(value);
						let form_control = this.getFormControl();
						form_control.setValue(value);
					}
				}));
		}
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions to prevent memory leak
		this.subscriptions.forEach(
			(OBJ_subscription: Subscription) => {
				OBJ_subscription.unsubscribe();
			}
		);
	}

	/**
	 * Function > setValue
	 * @param event
	 */
	setValue(event: any) {
		super.setValue(event.target.value || null);
		console.log(this.getFormControl());
	}
}
